import 'babel-polyfill'
import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import VueRx from 'vue-rx';
import * as VueGoogleMaps from 'vue2-google-maps';
// @ts-ignore
import VueGallerySlideshow from 'vue-gallery-slideshow';

import VueMeta from 'vue-meta';
// @ts-ignore
import VueFullPage from 'vue-fullpage.js';
import VueAnalytics from 'vue-analytics';
import 'fullpage.js/vendors/scrolloverflow';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import {i18n} from './plugins/i18n';
import * as firebase from '@/utils/firebase-config';
// @ts-ignore
import VueScrollMonitor from 'vue-scrollmonitor'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
// @ts-ignore
Vue.config.productionTip = false;

Vue.use(VueRx);
Vue.use(VueFullPage);
Vue.use(VueMeta);
Vue.use(VueScrollMonitor);
Vue.use(VueAnalytics, {
  id: `${process.env.VUE_APP_ANALYTICS_ID}`,
  router,
});

Vue.component('GallerySlideShow', VueGallerySlideshow);
// @ts-ignore
Vue.use(VueGoogleMaps, {
  load: {
    key: `${process.env.VUE_APP_MAPS_API_KEY}`,
    libraries: 'places, geometry',
  },
  installComponents: true,
});
Vue.component('GmapCluster', GmapCluster);

Sentry.init({
  dsn: 'https://316954227ecb444d835f3ca04f7c0286@sentry.io/5172641',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
  enabled: process.env.NODE_ENV === 'production',
  ignoreErrors: [
    'NavigationDuplicated',
    'Request failed with status code 401',
    'Uncaught (in promise) Error: Request failed with status code 401'
  ]
});

/**
 * Ensure Firebase initialization before laoding the app.
 */
let app: any = null;
firebase.auth.onAuthStateChanged(() => {
  if (app) {
    return;
  }

  app = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
});
